/* Spar-Abo in der Buy Box (snippets/ds-pdp-subscription.liquid, Sean 23.09.2026).
   Rendert die zwei Kaufoptionen aus der JSON-Konfiguration des Snippets und
   hängt beim Abo `selling_plan` + Menge ins Horizon-Produktformular. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ds-sub]');
  if (!root || root.dataset.dsSubReady) return;
  root.dataset.dsSubReady = '1';

  var cfg;
  try {
    cfg = JSON.parse(root.querySelector('[data-ds-sub-config]').textContent);
  } catch (e) {
    root.hidden = true;
    return;
  }

  var demo = /[?&]ds_abo_demo=1/.test(location.search);
  var plans = cfg.plans || [];
  if (!plans.length && demo) {
    plans = [
      { id: 'demo-1', name: 'Alle 1 Monat' },
      { id: 'demo-2', name: 'Alle 2 Monate' },
      { id: 'demo-3', name: 'Alle 3 Monate' },
    ];
  }
  if (!plans.length) { root.hidden = true; return; }

  /* Shopifys t-Filter liefert HTML-escaped Text ("&amp;", "&#39;"); vor dem
     eigenen Escaping einmal dekodieren, sonst steht "&amp;" sichtbar da. */
  var t = {};
  Object.keys(cfg.i18n || {}).forEach(function (k) {
    var ta = document.createElement('textarea');
    ta.innerHTML = String(cfg.i18n[k]);
    t[k] = ta.value;
  });
  var pairs = Number(cfg.pairs) || 3;
  /* Menge pro Lieferung: Einzelpaare = Paare, Packs = aufgerundete Packs (Liquid). */
  var qty = Number(cfg.qty) || pairs;
  var unitLabel = cfg.isPack ? t.per_pack : t.per_unit;

  /* Intervall-Label aus Plan-Name/-Option ableiten ("Alle 1 Monat" -> "Jeden
     Monat", "Every 3 months" -> "Alle 3 Monate"), damit es in DE/EN/FR
     einheitlich und uebersetzt erscheint. Ohne erkennbare Zahl bleibt der
     Seal-Name. */
  function intervalLabel(plan) {
    var src = (plan.option || '') + ' ' + (plan.name || '');
    var m = /(\d+)\s*(monat|month|mois|woche|week|semaine)/i.exec(src);
    if (!m) return plan.name;
    var n = Number(m[1]);
    var week = /woche|week|semaine/i.test(m[2]);
    if (n === 1) return week ? t.every_week : t.every_month;
    return (week ? t.every_n_weeks : t.every_n_months).replace('%n', String(n));
  }
  var form = document.querySelector('form[action*="/cart/add"]');
  var state = { mode: 'once', plan: String(plans[Math.min(2, plans.length - 1)].id), variant: String(cfg.selectedVariant) };

  function money(cents) {
    if (typeof window.dsMoney === 'function') return window.dsMoney(cents);
    return (cents / 100).toFixed(2) + ' ' + cfg.currency;
  }

  function currentVariantId() {
    var input = form && form.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : state.variant;
  }

  /* Preise fuer Variante + Plan; Demo = 10 % unter Einzelpreis. */
  function planPrice(variantId, planId) {
    var v = cfg.variants[variantId] || cfg.variants[Object.keys(cfg.variants)[0]];
    if (!v) return null;
    var base = v.price;
    var a = v.plans && v.plans[planId];
    var price = a ? a.price : demo ? Math.round(base * 0.9) : base;
    var compare = a && a.compare > price ? a.compare : base;
    var pct = compare > price ? Math.round(((compare - price) / compare) * 100) : 0;
    return { base: base, price: price, compare: compare, pct: pct };
  }

  /* Icon hinter "Spar-Abo": Paket mit Kreispfeilen (Sean 24.09.), als
     Inline-SVG im Theme-Schwarz statt Emoji, damit es auf allen Geraeten
     gleich aussieht. */
  var ICON =
    '<svg class="ds-sub__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
    '<path d="M4.5 9.2A8 8 0 0 1 18.6 6.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
    '<path d="M18.9 3.4v3.4h-3.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M19.5 14.8A8 8 0 0 1 5.4 17.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
    '<path d="M5.1 20.6v-3.4h3.4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M12 8.3l3.4 1.9v3.8L12 15.9l-3.4-1.9v-3.8L12 8.3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '<path d="M8.6 10.2L12 12.1l3.4-1.9M12 12.1v3.8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
    '</svg>';

  /* ---------- Markup ---------- */
  root.innerHTML =
    '<div role="radiogroup" aria-label="' + esc(t.aria_group) + '">' +
    '<label class="ds-sub__opt" data-ds-sub-opt="once">' +
    '<input type="radio" name="ds-sub-mode" value="once">' +
    '<span class="ds-sub__row"><span class="ds-sub__radio" aria-hidden="true"></span>' +
    '<span class="ds-sub__label"><span class="ds-sub__title">' + esc(t.once) + '</span></span>' +
    '<span class="ds-sub__price" data-ds-sub-once-price></span></span>' +
    '</label>' +
    '<label class="ds-sub__opt" data-ds-sub-opt="abo">' +
    '<input type="radio" name="ds-sub-mode" value="abo">' +
    '<span class="ds-sub__row"><span class="ds-sub__radio" aria-hidden="true"></span>' +
    '<span class="ds-sub__label"><span class="ds-sub__title">' + esc(t.abo) + ICON + '</span>' +
    '<span class="ds-ptag ds-ptag--sale ds-sub__badge" data-ds-sub-badge hidden></span>' +
    '<span class="ds-sub__sub" data-ds-sub-sub></span></span>' +
    '<span class="ds-sub__price" data-ds-sub-abo-price></span></span>' +
    '<span class="ds-sub__body">' +
    '<span class="ds-sub__field"><span>' + esc(t.interval_label) + '</span>' +
    '<select class="ds-sub__select" data-ds-sub-plan aria-label="' + esc(t.interval_label) + '">' +
    plans.map(function (p) { return '<option value="' + esc(String(p.id)) + '">' + esc(intervalLabel(p)) + '</option>'; }).join('') +
    '</select></span>' +
    '<span class="ds-sub__note" data-ds-sub-note></span>' +
    (demo ? '<span class="ds-sub__demo">' + esc(t.demo_note) + '</span>' : '') +
    '</span></label></div>';

  var els = {
    opts: root.querySelectorAll('[data-ds-sub-opt]'),
    radios: root.querySelectorAll('input[name="ds-sub-mode"]'),
    select: root.querySelector('[data-ds-sub-plan]'),
    oncePrice: root.querySelector('[data-ds-sub-once-price]'),
    aboPrice: root.querySelector('[data-ds-sub-abo-price]'),
    badge: root.querySelector('[data-ds-sub-badge]'),
    sub: root.querySelector('[data-ds-sub-sub]'),
    note: root.querySelector('[data-ds-sub-note]'),
  };
  els.select.value = state.plan;
  els.sub.textContent = cfg.isPack ? t.packs_note : t.pairs_note;

  /* ---------- Formular-Kopplung ---------- */
  function qtyInput() {
    if (!form) return null;
    var q = form.querySelector('input[name="quantity"]');
    if (!q) {
      q = document.createElement('input');
      q.type = 'hidden';
      q.name = 'quantity';
      q.value = '1';
      form.appendChild(q);
    }
    return q;
  }
  /* Seal fuegt ein eigenes <input name="selling_plan"> (leer oder mit Plan)
     ins Formular ein. Damit es beim Absenden nicht mit unserem Feld
     kollidiert, wird es umbenannt — sofort und bei jeder spaeteren
     Einfuegung (Seal rendert asynchron). */
  function neutralizeForeign() {
    if (!form) return;
    form.querySelectorAll('input[name="selling_plan"]:not([data-ds-sub-input]), select[name="selling_plan"]').forEach(function (el) {
      el.name = 'seal_selling_plan_disabled';
    });
  }
  if (form) {
    neutralizeForeign();
    new MutationObserver(neutralizeForeign).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['name'] });
    form.addEventListener('submit', neutralizeForeign, true);
  }
  function planInput(create) {
    if (!form) return null;
    var p = form.querySelector('input[name="selling_plan"][data-ds-sub-input]');
    if (!p && create) {
      p = document.createElement('input');
      p.type = 'hidden';
      p.name = 'selling_plan';
      p.setAttribute('data-ds-sub-input', '1');
      form.appendChild(p);
    }
    return p;
  }
  function applyToForm() {
    var q = qtyInput();
    if (state.mode === 'abo' && !demo) {
      planInput(true).value = state.plan;
      if (q) q.value = String(qty);
    } else {
      var p = planInput(false);
      if (p) p.remove();
      if (q) q.value = '1';
    }
    var submit = form && form.querySelector('button[type="submit"]');
    if (submit && demo) submit.disabled = state.mode === 'abo';
  }

  /* ---------- Anzeige ---------- */
  function render() {
    var vid = currentVariantId();
    state.variant = vid;
    var pp = planPrice(vid, state.plan);
    if (!pp) return;
    els.oncePrice.innerHTML = money(pp.base) + ' <span class="ds-sub__unit">' + esc(unitLabel) + '</span>';
    els.aboPrice.innerHTML =
      (pp.pct > 0 ? '<s>' + money(pp.base) + '</s>' : '') +
      money(pp.price) + ' <span class="ds-sub__unit">' + esc(unitLabel) + '</span>';
    if (pp.pct > 0) {
      els.badge.textContent = t.save.replace('%p', String(pp.pct));
      els.badge.hidden = false;
    } else {
      els.badge.hidden = true;
    }
    els.note.innerHTML =
      '<strong>' + t.per_delivery.replace('%s', money(pp.price * qty)) + '</strong> · ' + esc(t.cancel_note);
    els.opts.forEach(function (o) {
      var on = o.dataset.dsSubOpt === state.mode;
      o.classList.toggle('is-on', on);
      o.querySelector('input').checked = on;
    });
  }

  els.radios.forEach(function (r) {
    r.addEventListener('change', function () {
      state.mode = r.value;
      render();
      applyToForm();
    });
  });
  els.select.addEventListener('change', function () {
    state.plan = els.select.value;
    render();
    applyToForm();
  });
  els.select.addEventListener('click', function (e) { e.stopPropagation(); });

  /* Variantenwechsel: Horizon setzt input[name=id] per JS — nach Klicks auf
     den Variant-Picker kurz warten und neu rechnen. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(render, 80);
  });
  setInterval(function () {
    if (currentVariantId() !== state.variant) render();
  }, 1000);

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  render();
  applyToForm();
  root.hidden = false;
})();
